<template>
  <div class="hv-wrap">
    <ProgressBar v-if="loader" mode="indeterminate"
      style="height:3px;position:fixed;top:0;left:0;right:0;z-index:9999;border-radius:0"/>

    <!-- ── Selección de empresa (Generador puede trabajar con varias transportadoras) ── -->
    <div class="hv-empresa-selector" v-if="idRolActivo == 2 && customer_selected == null">
      <div class="hv-empresa-icon"><i class="pi pi-building"></i></div>
      <div class="hv-empresa-body">
        <div class="hv-empresa-title">Seleccione la empresa de transporte</div>
        <Dropdown v-model="customer_selected" :showClear="true"
          :options="customers_group" optionLabel="name" optionValue="id_customer"
          placeholder="Seleccione una empresa…" style="width:100%;max-width:420px"
          @change="onEmpresaSeleccionada" />
      </div>
    </div>

    <template v-if="idRolActivo != 2 || customer_selected != null">

    <!-- ── Topbar ── -->
    <div class="hv-topbar">
      <div>
        <h2 class="hv-title">Hoja de Vida de Vehículos
          <span class="hv-badge-total">{{ pagination.total }}</span>
        </h2>
        <p class="hv-sub">Gestión y seguimiento de la flota de vehículos</p>
      </div>
      <div class="hv-topbar-actions">
        <button class="hv-btn-outline" @click="toggleFiltros">
          <i class="pi pi-filter"></i> Filtrar
        </button>
        <button class="hv-btn-primary" @click="mostrarModalNuevo = true">
          <i class="pi pi-plus-circle"></i> Nuevo Vehículo
        </button>
      </div>
    </div>

    <!-- ── OverlayPanel Filtros ── -->
    <OverlayPanel ref="opFiltros" appendTo="body" :showCloseIcon="true" :style="{width:'440px'}">
      <div class="hv-filtros">
        <div class="hv-filtros-title"><i class="pi pi-filter"></i> Filtrar vehículos</div>

        <div class="hv-filtros-field">
          <label>Placa</label>
          <span class="p-input-icon-left" style="width:100%">
            <i class="pi pi-search"></i>
            <InputText v-model="frmfiltros.placa" placeholder="Ej. ABC123…"
              style="width:100%" @keydown.enter="aplicarFiltros" />
          </span>
        </div>

        <div class="hv-filtros-grid">
          <div class="hv-filtros-field">
            <label>Clase vehículo</label>
            <Dropdown v-model="frmfiltros.clase" :options="opciones_clase"
              optionLabel="label" optionValue="value" placeholder="Todas"
              :showClear="true" style="width:100%" />
          </div>
          <div class="hv-filtros-field">
            <label>Combustible</label>
            <Dropdown v-model="frmfiltros.combustible" :options="opciones_combustible"
              optionLabel="label" optionValue="value" placeholder="Todos"
              :showClear="true" style="width:100%" />
          </div>
          <div class="hv-filtros-field">
            <label>Estado SOAT</label>
            <Dropdown v-model="frmfiltros.estado_soat" :options="opciones_soat"
              optionLabel="label" optionValue="value" placeholder="Todos"
              :showClear="true" style="width:100%" />
          </div>
          <div class="hv-filtros-field">
            <label>Estado RTM</label>
            <Dropdown v-model="frmfiltros.estado_rtm" :options="opciones_rtm"
              optionLabel="label" optionValue="value" placeholder="Todos"
              :showClear="true" style="width:100%" />
          </div>
        </div>

        <div class="hv-filtros-field">
          <label>Tipo de servicio</label>
          <Dropdown v-model="frmfiltros.tipo_servicio" :options="opciones_tipo_servicio"
            optionLabel="label" optionValue="value" placeholder="Todos"
            :showClear="true" style="width:100%" />
        </div>

        <div class="hv-filtros-actions">
          <button class="hv-btn-outline" @click="limpiarFiltros">
            <i class="pi pi-filter-slash"></i> Limpiar
          </button>
          <button class="hv-btn-primary" @click="aplicarFiltros">
            <i class="pi pi-search"></i> Buscar
          </button>
        </div>
      </div>
    </OverlayPanel>

    <!-- ── Tabla ── -->
    <div class="hv-tabla-wrap">

      <!-- Estado vacío -->
      <div v-if="!loader && vehiculos.length === 0" class="hv-empty">
        <div class="hv-empty-icon"><i class="pi pi-truck"></i></div>
        <h3>No hay vehículos registrados</h3>
        <p>Comienza registrando el primer vehículo para tu flota.</p>
        <button class="hv-btn-primary" @click="mostrarModalNuevo = true">
          <i class="pi pi-plus"></i> Crear el primer vehículo
        </button>
      </div>
      
      <table v-else class="hv-tabla">
        <thead>
          <tr>
            <th style="width:56px">Foto</th>
            <th style="width:110px">Placa</th>
            <th>Marca / Línea</th>
            <th style="width:80px">Modelo</th>
            <th>Clase</th>
            <th>Propietario</th>
            <th style="width:120px">SOAT</th>
            <th style="width:120px">RTM</th>
            <th style="width:120px">Comparendos</th>
            <th style="width:115px">Última Sync.</th>
            <th>Comb. / Servicio</th>
            <th style="width:90px">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loader">
            <tr v-for="n in 5" :key="'sk'+n">
              <td colspan="12"><div class="hv-skeleton-row"></div></td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="(data, i) in vehiculos" :key="i">

              <!-- Foto -->
              <td>
                <div class="hv-foto-wrap">
                  <img v-if="fotoVehiculo(data)" :src="fotoVehiculo(data)" class="hv-foto" alt="foto" />
                  <div v-else class="hv-foto-placeholder"><i class="pi pi-truck"></i></div>
                </div>
              </td>

              <!-- Placa -->
              <td>
                <span class="hv-placa-badge">{{ data.plate }}</span>
                <div v-if="!data.sincronizado" class="hv-sub mt-1">
                  <span class="hv-tag-sec">Sin sync</span>
                </div>
              </td>

              <!-- Marca / Línea -->
              <td>
                <strong class="hv-strong">{{ vAttr(data,'marca') || '—' }}</strong>
                <div class="hv-sub">{{ vAttr(data,'linea') || '' }}</div>
              </td>

              <!-- Modelo -->
              <td class="hv-center">{{ vAttr(data,'modelo') || '—' }}</td>

              <!-- Clase -->
              <td><span class="hv-chip">{{ vAttr(data,'clase_vehiculo') || '—' }}</span></td>

              <!-- Propietario -->
              <td><span class="hv-sub">Doc: {{ vAttr(data,'nro_doc') || '—' }}</span></td>

              <!-- SOAT -->
              <td>
                <span :class="['hv-status', soatEstado(data).cls]">{{ soatEstado(data).label }}</span>
                <div class="hv-sub">{{ soatVence(data) }}</div>
              </td>

              <!-- RTM -->
              <td>
                <span :class="['hv-status', rtmEstado(data).cls]">{{ rtmEstado(data).label }}</span>
                <div class="hv-sub">{{ rtmVence(data) }}</div>
              </td>

              <!-- Comparendos -->
              <td>
                <span :class="['hv-count', nComparendos(data) > 0 ? 'hv-count--danger' : 'hv-count--ok']">
                  {{ nComparendos(data) }}
                </span>
                <div v-if="nComparendos(data) > 0" class="hv-sub hv-rojo">
                  {{ fmtCOP(data._json?.simitv?.resumen?.total_pagar) }}
                </div>
              </td>

              <!-- Última Sync -->
              <td><span class="hv-sync-fecha">{{ data.updated_at ? fmtFecha(data.updated_at) : '—' }}</span></td>

              <!-- Comb / Servicio -->
              <td>
                <span class="hv-chip hv-chip-blue">{{ vAttr(data,'tipo_combustible') || '—' }}</span>
                <div class="hv-sub mt-1">{{ vAttr(data,'tipo_servicio') || '—' }}</div>
              </td>

              <!-- Acciones -->
              <td>
                <div class="hv-acciones">
                  <button class="hv-btn-icon" title="Ver detalle" @click="verDetalle(data)">
                    <i class="pi pi-eye"></i>
                  </button>
                  <button
                    :class="['hv-btn-icon',
                      data._sync_estado === 'ok'         ? 'hv-btn-icon--ok'
                      : data._sync_estado === 'en_proceso' ? 'hv-btn-icon--warn'
                      : data._sync_estado === 'error'      ? 'hv-btn-icon--danger'
                      : '']"
                    :title="data._sync_estado === 'en_proceso' ? 'En proceso…'
                          : data._sync_estado === 'error'      ? 'Error — reintentar'
                          : 'Resincronizar'"
                    :disabled="data._sincronizando"
                    @click="resincronizar(data)">
                    <i :class="data._sincronizando ? 'pi pi-spin pi-spinner'
                              : data._sync_estado === 'ok'         ? 'pi pi-check'
                              : data._sync_estado === 'en_proceso' ? 'pi pi-clock'
                              : data._sync_estado === 'error'      ? 'pi pi-times'
                              : 'pi pi-refresh'"></i>
                  </button>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <!-- Paginación -->
      <div class="hv-pagination" v-if="vehiculos.length > 0 || pagination.total > 0">
        <div class="hv-pagination-left">
          <span class="hv-pag-label">Filas por página</span>
          <select class="hv-per-page" v-model="porPagina" @change="cargarVehiculos(1)">
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
        <span class="hv-pag-info">{{ pagination.from }}–{{ pagination.to }} de {{ pagination.total }}</span>
        <Paginator :rows="pagination.per_page" :totalRecords="pagination.total"
          @page="onChangePage" class="hv-paginator" />
      </div>
    </div>

    <!-- ══ MODAL DETALLE ══ -->
    <Dialog v-model:visible="modalDetalle" :style="{width:'82vw'}" :modal="true"
      header="Hoja de Vida del Vehículo" class="hv-dialog">
      <div v-if="sel">

        <!-- Header vehículo -->
        <div class="hv-modal-header">
          <div class="hv-modal-icon"><i class="pi pi-truck"></i></div>
          <div class="hv-modal-main">
            <div class="hv-placa-badge-lg">{{ sel.plate }}</div>
            <div class="hv-modal-title">
              {{ vAttr(sel,'marca') }} {{ vAttr(sel,'linea') }}
              <span class="hv-modelo-pill">{{ vAttr(sel,'modelo') }}</span>
            </div>
            <div class="hv-modal-sub">
              {{ vAttr(sel,'clase_vehiculo') }} · {{ vAttr(sel,'tipo_servicio') }} · {{ vAttr(sel,'tipo_combustible') }}
            </div>
          </div>
          <div class="hv-modal-badges">
            <div class="hv-badge-item">
              <span class="hv-badge-lbl">SOAT</span>
              <span :class="['hv-status', soatEstado(sel).cls]">{{ soatEstado(sel).label }}</span>
              <span class="hv-badge-fecha">{{ soatVence(sel) }}</span>
            </div>
            <div class="hv-badge-item">
              <span class="hv-badge-lbl">RTM</span>
              <span :class="['hv-status', rtmEstado(sel).cls]">{{ rtmEstado(sel).label }}</span>
              <span class="hv-badge-fecha">{{ rtmVence(sel) }}</span>
            </div>
            <div class="hv-badge-item">
              <span class="hv-badge-lbl">Comparendos</span>
              <span :class="['hv-count', nComparendos(sel) === 0 ? 'hv-count--ok' : 'hv-count--danger']">
                {{ nComparendos(sel) === 0 ? 'Sin deuda' : nComparendos(sel) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <TabView class="hv-tabview mt-3">

          <!-- Datos -->
          <TabPanel>
            <template #header><i class="pi pi-info-circle mr-2"></i>Datos del Vehículo</template>
            <div class="hv-seccion-grid">
              <div class="hv-seccion">
                <div class="hv-seccion-titulo"><i class="pi pi-id-card"></i> Identificación</div>
                <div class="hv-kv-grid">
                  <span class="hv-kv-lbl">Placa</span>        <span><span class="hv-placa-badge">{{ sel.plate }}</span></span>
                  <span class="hv-kv-lbl">Marca</span>        <span class="hv-bold">{{ vAttr(sel,'marca') || '—' }}</span>
                  <span class="hv-kv-lbl">Línea</span>        <span>{{ vAttr(sel,'linea') || '—' }}</span>
                  <span class="hv-kv-lbl">Modelo</span>       <span>{{ vAttr(sel,'modelo') || '—' }}</span>
                  <span class="hv-kv-lbl">Color</span>        <span>{{ vAttr(sel,'color') || '—' }}</span>
                  <span class="hv-kv-lbl">Clase</span>        <span>{{ vAttr(sel,'clase_vehiculo') || '—' }}</span>
                  <span class="hv-kv-lbl">Servicio</span>     <span>{{ vAttr(sel,'tipo_servicio') || '—' }}</span>
                  <span class="hv-kv-lbl">Combustible</span>  <span>{{ vAttr(sel,'tipo_combustible') || '—' }}</span>
                  <span class="hv-kv-lbl">Carrocería</span>   <span>{{ vAttr(sel,'tipo_carroceria') || '—' }}</span>
                  <span class="hv-kv-lbl">Estado</span>
                  <span>
                    <span :class="['hv-status', vAttr(sel,'estado_vehiculo')==='ACTIVO'?'hv-status--ok':'hv-status--warn']">
                      {{ vAttr(sel,'estado_vehiculo') || '—' }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="hv-seccion">
                <div class="hv-seccion-titulo"><i class="pi pi-cog"></i> Datos Técnicos</div>
                <div class="hv-kv-grid">
                  <span class="hv-kv-lbl">Cilindraje</span>   <span>{{ vAttr(sel,'cilindraje') ? vAttr(sel,'cilindraje')+' cc' : '—' }}</span>
                  <span class="hv-kv-lbl">Núm. ejes</span>    <span>{{ vAttr(sel,'num_ejes') ?? '—' }}</span>
                  <span class="hv-kv-lbl">Cap. carga</span>   <span>{{ vAttr(sel,'capacidad_carga') ?? '—' }}</span>
                  <span class="hv-kv-lbl">Peso bruto</span>   <span>{{ vAttr(sel,'peso_bruto_vehicular') ?? '—' }}</span>
                  <span class="hv-kv-lbl">Pasajeros</span>    <span>{{ vAttr(sel,'capacidad_pasajeros') ?? '—' }}</span>
                  <span class="hv-kv-lbl">N° Motor</span>     <span class="hv-mono">{{ vAttr(sel,'numero_motor') || '—' }}</span>
                  <span class="hv-kv-lbl">N° Chasis</span>    <span class="hv-mono">{{ vAttr(sel,'numero_chasis') || '—' }}</span>
                  <span class="hv-kv-lbl">N° VIN</span>       <span class="hv-mono">{{ vAttr(sel,'numero_vin') || '—' }}</span>
                  <span class="hv-kv-lbl">N° Serie</span>     <span class="hv-mono">{{ vAttr(sel,'numero_serie') || '—' }}</span>
                </div>
              </div>
              <div class="hv-seccion">
                <div class="hv-seccion-titulo"><i class="pi pi-book"></i> Registro</div>
                <div class="hv-kv-grid">
                  <span class="hv-kv-lbl">Nro. Licencia</span>    <span class="hv-mono">{{ vAttr(sel,'nro_licencia_transito') || '—' }}</span>
                  <span class="hv-kv-lbl">Autoridad</span>        <span>{{ vAttr(sel,'autoridad_transito') || '—' }}</span>
                  <span class="hv-kv-lbl">Matrícula</span>        <span>{{ fmtFechaISO(vAttr(sel,'fecha_matricula')) }}</span>
                  <span class="hv-kv-lbl">Consulta</span>         <span>{{ fmtFechaHora(vAttr(sel,'fecha_consulta')) }}</span>
                  <span class="hv-kv-lbl">Doc. propietario</span> <span class="hv-mono">{{ vAttr(sel,'nro_doc') || '—' }}</span>
                  <span class="hv-kv-lbl">Blindado</span>
                  <span>
                    <span :class="['hv-status', vAttr(sel,'blindado')?'hv-status--warn':'hv-status--sec']">
                      {{ vAttr(sel,'blindado') ? 'Sí' : 'No' }}
                    </span>
                  </span>
                  <span class="hv-kv-lbl">Repotenciado</span>
                  <span>
                    <span :class="['hv-status', vAttr(sel,'repotenciado')?'hv-status--warn':'hv-status--sec']">
                      {{ vAttr(sel,'repotenciado') ? 'Sí' : 'No' }}
                    </span>
                  </span>
                  <span class="hv-kv-lbl">Gravámenes</span>
                  <span>
                    <span :class="['hv-status', vAttr(sel,'gravamenes_propiedad')?'hv-status--danger':'hv-status--ok']">
                      {{ vAttr(sel,'gravamenes_propiedad') ? 'Con gravamen' : 'Sin gravamen' }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </TabPanel>

          <!-- SOAT -->
          <TabPanel>
            <template #header><i class="pi pi-shield mr-2"></i>SOAT</template>
            <div v-if="!soatList(sel).length" class="hv-empty-tab"><i class="pi pi-times-circle"></i> Sin registros SOAT</div>
            <div v-for="(s,i) in soatList(sel)" :key="i" class="hv-poliza-card"
              :class="s.estado === 'VIGENTE' ? 'hv-poliza-vigente' : ''">
              <div class="hv-poliza-header">
                <span class="hv-poliza-entidad">{{ s.entidad }}</span>
                <span :class="['hv-status', s.estado==='VIGENTE'?'hv-status--ok':'hv-status--sec']">{{ s.estado }}</span>
              </div>
              <div class="hv-poliza-kv">
                <div><span class="hv-kv-lbl">N° Póliza</span><span class="hv-mono">{{ s.numero_poliza }}</span></div>
                <div><span class="hv-kv-lbl">Expedición</span><span>{{ fmtFechaISO(s.fecha_expedicion) }}</span></div>
                <div><span class="hv-kv-lbl">Inicio vigencia</span><span>{{ fmtFechaISO(s.fecha_inicio_vigencia) }}</span></div>
                <div>
                  <span class="hv-kv-lbl">Fin vigencia</span>
                  <span :class="s.estado==='VIGENTE'?'hv-fecha-ok':'hv-fecha-vencida'">{{ fmtFechaISO(s.fecha_fin_vigencia) }}</span>
                </div>
                <div><span class="hv-kv-lbl">Tarifa</span><span>{{ s.codigo_tarifa }}</span></div>
              </div>
            </div>
          </TabPanel>

          <!-- RTM -->
          <TabPanel>
            <template #header><i class="pi pi-wrench mr-2"></i>RTM</template>
            <div v-if="!rtmList(sel).length" class="hv-empty-tab"><i class="pi pi-times-circle"></i> Sin registros RTM</div>
            <div v-for="(r,i) in rtmList(sel)" :key="i" class="hv-poliza-card"
              :class="r.vigente ? 'hv-poliza-vigente' : ''">
              <div class="hv-poliza-header">
                <span class="hv-poliza-entidad">{{ r.cda }}</span>
                <span :class="['hv-status', r.vigente?'hv-status--ok':'hv-status--sec']">{{ r.vigente?'VIGENTE':'VENCIDA' }}</span>
              </div>
              <div class="hv-poliza-kv">
                <div><span class="hv-kv-lbl">N° Certificado</span><span class="hv-mono">{{ r.nro_certificado }}</span></div>
                <div><span class="hv-kv-lbl">Tipo revisión</span><span>{{ r.tipo_revision }}</span></div>
                <div><span class="hv-kv-lbl">Expedición</span><span>{{ fmtFechaISO(r.fecha_expedicion) }}</span></div>
                <div>
                  <span class="hv-kv-lbl">Vigencia hasta</span>
                  <span :class="r.vigente?'hv-fecha-ok':'hv-fecha-vencida'">{{ fmtFechaISO(r.fecha_vigencia) }}</span>
                </div>
                <div>
                  <span class="hv-kv-lbl">Consistente</span>
                  <span :class="['hv-status', r.informacion_consistente?'hv-status--ok':'hv-status--danger']">
                    {{ r.informacion_consistente ? 'Sí' : 'No' }}
                  </span>
                </div>
              </div>
            </div>
          </TabPanel>

          <!-- Solicitudes -->
          <TabPanel>
            <template #header><i class="pi pi-list mr-2"></i>Solicitudes RUNT</template>
            <div v-if="!solicitudesList(sel).length" class="hv-empty-tab"><i class="pi pi-times-circle"></i> Sin solicitudes</div>
            <table v-else class="hv-tabla hv-tabla--sm">
              <thead><tr>
                <th>N° Solicitud</th><th>Fecha</th><th>Entidad</th><th>Trámites</th><th>Estado</th>
              </tr></thead>
              <tbody>
                <tr v-for="(s,i) in solicitudesList(sel)" :key="i">
                  <td><span class="hv-mono">{{ s.nro_solicitud }}</span></td>
                  <td>{{ fmtFechaISO(s.fecha_solicitud) }}</td>
                  <td>{{ s.entidad }}</td>
                  <td><span class="hv-sub">{{ s.tramites }}</span></td>
                  <td>
                    <span :class="['hv-status', s.estado==='APROBADA'?'hv-status--ok':s.estado==='AUTORIZADA'?'hv-status--info':'hv-status--warn']">
                      {{ s.estado }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </TabPanel>

          <!-- SIMIT -->
          <TabPanel>
            <template #header>
              <i class="pi pi-exclamation-triangle mr-2"></i>SIMIT
              <span v-if="nComparendos(sel) > 0" class="hv-tab-badge">{{ nComparendos(sel) }}</span>
            </template>

            <div v-if="nComparendos(sel) === 0" class="hv-simit-clean">
              <i class="pi pi-check-circle hv-simit-icon"></i>
              <strong>¡Sin comparendos!</strong>
              <p>{{ sel._json?.simitv?.estado_general }}</p>
            </div>

            <template v-else>
              <div class="hv-deuda-resumen mb-3">
                <div class="hv-deuda-item">
                  <span class="hv-kv-lbl">Comparendos</span>
                  <span class="hv-count hv-count--danger">{{ nComparendos(sel) }}</span>
                </div>
                <div class="hv-deuda-item">
                  <span class="hv-kv-lbl">Multas</span>
                  <span class="hv-count hv-count--warn">{{ sel._json?.simitv?.resumen?.multas ?? 0 }}</span>
                </div>
                <div class="hv-deuda-item">
                  <span class="hv-kv-lbl">Total a pagar</span>
                  <strong class="hv-deuda-total">{{ fmtCOP(sel._json?.simitv?.resumen?.total_pagar) }}</strong>
                </div>
              </div>

              <table class="hv-tabla hv-tabla--sm">
                <thead><tr>
                  <th style="width:100px">Fecha</th>
                  <th style="width:80px">Tipo</th>
                  <th style="width:65px">Cód.</th>
                  <th>Secretaría</th>
                  <th>Estado</th>
                  <th style="width:100px">Valor</th>
                </tr></thead>
                <tbody>
                  <tr v-for="(c,i) in comparendosList(sel)" :key="i">
                    <td>{{ fmtFechaISO(c.fecha_imposicion) }}</td>
                    <td>
                      <span :class="['hv-status', c.tipo==='multa'?'hv-status--danger':'hv-status--warn']">
                        {{ c.tipo?.toUpperCase() }}
                      </span>
                    </td>
                    <td><span class="hv-mono hv-bold">{{ c.infraccion?.substring(0,3) }}</span></td>
                    <td><span class="hv-sub">{{ c.secretaria }}</span></td>
                    <td>
                      <span :class="['hv-status', c.estado?.toLowerCase().includes('coactivo')?'hv-status--danger':'hv-status--warn']">
                        {{ c.estado }}
                      </span>
                    </td>
                    <td>
                      {{ parseValorCOP(c.valor_cop) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="hv-simit-nota mt-2">
                <i class="pi pi-info-circle"></i>
                El valor total consolidado aparece en el resumen. Los valores individuales por comparendo corresponden al consolidado del SIMIT.
              </div>
            </template>
          </TabPanel>

          <!-- Fotos -->
          <TabPanel>
            <template #header>
              <i class="pi pi-images mr-2"></i>Fotos
              <span v-if="fotosCatalogo(sel).length" class="hv-tab-badge hv-tab-badge--blue">
                {{ fotosCatalogo(sel).length }}
              </span>
            </template>

            <div v-if="!fotosCatalogo(sel).length" class="hv-empty-tab">
              <i class="pi pi-times-circle"></i> Sin fotos registradas para este vehículo
            </div>

            <div v-else class="hv-fotos-det-grid">
              <div
                v-for="foto in fotosCatalogo(sel)"
                :key="foto.key"
                class="hv-foto-det-card"
              >
                <div class="hv-foto-det-header">
                  <i :class="['pi', foto.icono, 'mr-1']"></i>{{ foto.label }}
                </div>

                <div v-if="foto.urlPublica" class="hv-foto-det-preview">
                  <img :src="foto.urlPublica" :alt="foto.label" class="hv-foto-det-img" />
                  <a :href="foto.urlPublica" target="_blank" class="hv-foto-det-open">
                    <i class="pi pi-external-link mr-1"></i>Abrir
                  </a>
                </div>

                <div v-else-if="foto.loading"
                  class="hv-foto-det-placeholder hv-foto-det-placeholder--loading">
                  <i class="pi pi-spin pi-spinner"></i><span>Cargando…</span>
                </div>

                <div v-else-if="foto.error"
                  class="hv-foto-det-placeholder hv-foto-det-placeholder--error">
                  <i class="pi pi-times-circle"></i>
                  <span>{{ foto.error }}</span>
                  <button class="hv-btn-outline" style="font-size:.72rem;padding:.25rem .6rem;margin-top:.4rem"
                    @click="verFotoDetalle(foto.key, foto.urlEncriptada)">
                    <i class="pi pi-refresh mr-1"></i>Reintentar
                  </button>
                </div>

                <div v-else
                  class="hv-foto-det-placeholder hv-foto-det-placeholder--clickable"
                  @click="verFotoDetalle(foto.key, foto.urlEncriptada)"
                >
                  <i class="pi pi-eye"></i>
                  <span>Clic para ver</span>
                  <small>Carga bajo demanda</small>
                </div>
              </div>
            </div>

            <div v-if="fotosCatalogo(sel).length" class="hv-simit-nota mt-3">
              <i class="pi pi-info-circle"></i>
              Las imágenes se cargan individualmente. No se almacenan en el sistema.
            </div>
          </TabPanel>
        </TabView>
      </div>
      <template #footer>
        <button class="hv-btn-outline" @click="modalDetalle = false">
          <i class="pi pi-times"></i> Cerrar
        </button>
      </template>
    </Dialog>

    </template>

    <ModalNuevoVehiculo
      v-model="mostrarModalNuevo"
      :id-rol="idRolActivo"
      :id-customer="customer_selected"
      :placa-inicial="resincronizandoExistente ? _placaResincronizar : ''"
      :documento-inicial="resincronizandoExistente ? _docPropietario : ''"
      :modo-resincronizar="resincronizandoExistente"
      @guardado="onGuardadoOResincronizado"
      @hide="onCerrarModal"
    />
  </div>
</template>

<script>
import ModalNuevoVehiculo from './modalHvvehiculo.vue';

export default {
  components: { ModalNuevoVehiculo },

  data() {
    return {
      mostrarModalNuevo: false,
      idRolActivo:       null,
      customers_group:   [],
      customer_selected: null,
      vehiculos:         [],
      loader:            false,
      modalDetalle:      false,
      resincronizandoExistente: false,
      _placaResincronizar:      '',
      _docPropietario:          '',
      _rowResincronizando:      null,
      sel:      null,
      porPagina: 25,
      pagination: { current_page:1, from:0, to:0, total:0, per_page:25, last_page:1 },
      frmfiltros: { placa:'', clase:null, estado_soat:null, estado_rtm:null, combustible:null, tipo_servicio:null },
      opciones_clase:         [{label:'Camión',value:'CAMION'},{label:'Tractocamión',value:'TRACTOCAMION'},{label:'Furgón',value:'FURGON'},{label:'Camioneta',value:'CAMIONETA'},{label:'Bus',value:'BUS'},{label:'Motocicleta',value:'MOTOCICLETA'}],
      opciones_soat:          [{label:'Vigente',value:'VIGENTE'},{label:'Vencido',value:'VENCIDO'},{label:'Sin datos',value:'SIN_DATOS'}],
      opciones_rtm:           [{label:'Vigente',value:'VIGENTE'},{label:'Vencido',value:'VENCIDO'},{label:'Sin datos',value:'SIN_DATOS'}],
      opciones_combustible:   [{label:'Diesel',value:'DIESEL'},{label:'Gasolina',value:'GASOLINA'},{label:'Gas',value:'GAS'},{label:'Eléctrico',value:'ELECTRICO'}],
      opciones_tipo_servicio: [{label:'Público',value:'PUBLICO'},{label:'Particular',value:'PARTICULAR'},{label:'Oficial',value:'OFICIAL'}],
      fotosDetalle: {},
      fotosDetalleLoading: {},
      fotosDetalleError: {},
    };
  },

  mounted() {
    const cookie = {};
    document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
    this.idRolActivo = cookie['IdRol'] ?? null;
    if (String(this.idRolActivo) === '2') {
      this.cargarEmpresas();
    } else {
      this.cargarVehiculos(1);
    }
  },

  methods: {
    cargarEmpresas() {
      this.loader = true;
      const cookie = {};
      document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
      window.api.call('post', '/cargar_customers?&page=1', {
        email: cookie['Email'], id_rol: cookie['IdRol'],
      }).then(res => {
        if (res.status === 200) {
          this.customers_group = res.data.data;
          if (res.data.data.length === 1) {
            this.customer_selected = res.data.data[0].id_customer;
            this.cargarVehiculos(1);
          } else {
            this.loader = false;
          }
        }
      }).catch(() => {
        this.loader = false;
        this.$toast.add({ severity:'error', summary:'Error', detail:'No se pudo cargar las empresas', life:5000 });
      });
    },

    onEmpresaSeleccionada() {
      if (this.customer_selected == null) return;
      this.cargarVehiculos(1);
    },

    toggleFiltros(event) { this.$refs.opFiltros.toggle(event); },

    aplicarFiltros() {
      this.$refs.opFiltros.hide();
      this.cargarVehiculos(1);
    },

    limpiarFiltros() {
      this.frmfiltros = { placa:'', clase:null, estado_soat:null, estado_rtm:null, combustible:null, tipo_servicio:null };
      this.$refs.opFiltros.hide();
      this.cargarVehiculos(1);
    },

    cargarVehiculos(page) {
      this.loader = true;
      const cookie = {};
      document.cookie.split(';').forEach(el => { const [k,v]=el.split('='); cookie[k.trim()]=decodeURIComponent(v??''); });
      window.api.call('post', `/cargar_vehiculos_hv?page=${page}`, {
        email: cookie['Email'], id_rol: cookie['IdRol'], id_customer: this.customer_selected,
        frmfiltros: this.frmfiltros, per_page: this.porPagina,
      }).then(res => {
        if (res.status === 200) {
          const raw = res.data.data?.data ?? [];
          this.vehiculos = raw.map(v => ({
            ...v, _json: this._parseJson(v.data_json),
            _sincronizando: false, _sync_estado: null,
          }));
          const meta = res.data.data;
          this.pagination = { current_page:meta.current_page, from:meta.from??0, to:meta.to??0, total:meta.total, per_page:meta.per_page, last_page:meta.last_page };
        }
      }).catch(() => {
        this.$toast.add({ severity:'error', summary:'Error', detail:'No se pudo cargar la lista', life:5000 });
      }).finally(() => { this.loader = false; });
    },

    onGuardadoOResincronizado() {
      if (this.resincronizandoExistente && this._rowResincronizando) {
        this._rowResincronizando._sync_estado = 'ok';
        this._rowResincronizando._sincronizando = false;
        this._rowResincronizando = null;
        this.resincronizandoExistente = false;
      }
      this.cargarVehiculos(this.pagination.current_page);
    },

    onCerrarModal() {
      if (this.resincronizandoExistente && this._rowResincronizando) {
        this._rowResincronizando._sincronizando = false;
        this._rowResincronizando = null;
      }
      this.resincronizandoExistente = false;
    },

    _parseJson(raw) {
      if (!raw) return null;
      try { return typeof raw === 'string' ? JSON.parse(raw) : raw; } catch { return null; }
    },
    parseValorCOP(valor) {
        if (!valor) return '$0';

        // Convertir a número
        let numero = Number(valor);

        // Si viene exageradamente grande
        // puedes dividirlo según la escala real
        numero = numero / 1000000;

        return new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(numero);
    },

    onChangePage(event) { this.cargarVehiculos(event.page + 1); },

    vAttr(row, campo) { return row._json?.runt?.vehiculo?.[campo] ?? null; },
    fotoVehiculo(row) { return row._json?.fotos_storage?.frontal ?? row._json?.foto_url ?? null; },

    soatList(row) { return row._json?.runt?.soat ?? []; },
    soatEstado(row) {
      const list = this.soatList(row);
      if (!list.length) return { label:'Sin datos', cls:'hv-status--sec' };
      const ultimo = list.reduce((a,b) => new Date(a.fecha_fin_vigencia??0) > new Date(b.fecha_fin_vigencia??0) ? a : b);
      return ultimo.estado === 'VIGENTE'
        ? { label:'VIGENTE', cls:'hv-status--ok' }
        : { label:'VENCIDO', cls:'hv-status--danger' };
    },
    soatVence(row) {
      const list = this.soatList(row);
      if (!list.length) return '';
      const ultimo = list.reduce((a,b) => new Date(a.fecha_fin_vigencia??0) > new Date(b.fecha_fin_vigencia??0) ? a : b);
      return ultimo.fecha_fin_vigencia ? this.fmtFechaISO(ultimo.fecha_fin_vigencia) : '';
    },

    rtmList(row) { return row._json?.runt?.rtm ?? []; },
    rtmEstado(row) {
      const list = this.rtmList(row);
      if (!list.length) return { label:'Sin datos', cls:'hv-status--sec' };
      const ultimo = list.reduce((a,b) => new Date(a.fecha_vigencia??0) > new Date(b.fecha_vigencia??0) ? a : b);
      return ultimo.vigente
        ? { label:'VIGENTE', cls:'hv-status--ok' }
        : { label:'VENCIDA', cls:'hv-status--danger' };
    },
    rtmVence(row) {
      const list = this.rtmList(row);
      if (!list.length) return '';
      const ultimo = list.reduce((a,b) => new Date(a.fecha_vigencia??0) > new Date(b.fecha_vigencia??0) ? a : b);
      return ultimo.fecha_vigencia ? this.fmtFechaISO(ultimo.fecha_vigencia) : '';
    },

    comparendosList(row) { return row._json?.simitv?.comparendos ?? []; },
    nComparendos(row)    { return this.comparendosList(row).length; },
    solicitudesList(row) { return row._json?.runt?.solicitudes ?? []; },

    verDetalle(row) { this.sel = row; this.modalDetalle = true;this.fotosDetalle = {};},

    resincronizar(row) {
      this._rowResincronizando = row; row._sync_estado = null;
      this._placaResincronizar = row.plate;
      this._docPropietario = row._json?.runt?.vehiculo?.nro_doc ?? '';
      this.resincronizandoExistente = true;
      this.mostrarModalNuevo = true;
    },

    fmtCOP(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      let v = typeof valor === 'string' ? parseFloat(valor.replace(/\./g,'').replace(',','.')) : valor;
      if (isNaN(v)) return '—';
      return new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', minimumFractionDigits:0, maximumFractionDigits:0 }).format(v);
    },

    fmtFechaISO(f) {
      if (!f) return '—';
      const [y,m,d] = f.substring(0,10).split('-');
      return `${d}/${m}/${y}`;
    },
    fmtFecha(f) {
      if (!f) return '—';
      return new Date(f).toLocaleDateString('es-CO', { day:'2-digit', month:'short', year:'numeric' });
    },
    fmtFechaHora(f) {
      if (!f) return '—';
      return new Date(f).toLocaleString('es-CO', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });
    },
    async verFotoDetalle(key, urlEncriptada) {
        if (this.fotosDetalle[key]) return;

        this.$set ? this.$set(this.fotosDetalleLoading, key, true)
                  : (this.fotosDetalleLoading = { ...this.fotosDetalleLoading, [key]: true });
        this.$set ? this.$set(this.fotosDetalleError, key, null)
                  : (this.fotosDetalleError   = { ...this.fotosDetalleError,   [key]: null });

        const cookie = {};
        document.cookie.split(';').forEach(el => {
            const [k, v] = el.split('=');
            cookie[k.trim()] = decodeURIComponent(v ?? '');
        });

        try {
            const res = await window.api.call('post', '/img_public', {
                email:      cookie['Email'],
                id_rol:     this.idRolActivo,
                imagenes:   [urlEncriptada],
                onlyimages: true,
            });

            const blob = res.data?.data?.images?.[0]?.blob ?? null;
            if (blob) {
                this.fotosDetalle = { ...this.fotosDetalle, [key]: blob };
            } else {
                this.fotosDetalleError = { ...this.fotosDetalleError, [key]: 'No se pudo obtener.' };
            }
        } catch {
            this.fotosDetalleError = { ...this.fotosDetalleError, [key]: 'Error al cargar.' };
        } finally {
            this.fotosDetalleLoading = { ...this.fotosDetalleLoading, [key]: false };
        }
    },

    fotosCatalogo(row) {
        if (!row) return [];
        // Las fotos vienen en data_json raíz (no dentro de runt)
        const src = row._json ?? {};
        return [
            { key: 'Foto_vehiculo_frontal',     label: 'Frontal',       icono: 'pi-car'    },
            { key: 'Foto_vehiculo_posterior',   label: 'Posterior',     icono: 'pi-car'    },
            { key: 'Foto_vehiculo_lateral_der', label: 'Lateral Der.',  icono: 'pi-car'    },
            { key: 'Foto_vehiculo_lateral_izq', label: 'Lateral Izq.',  icono: 'pi-car'    },
            { key: 'Foto_soat',                 label: 'SOAT',          icono: 'pi-shield' },
            { key: 'Foto_tecnomecanica',        label: 'Tecno.',        icono: 'pi-wrench' },
        ].map(f => ({
            ...f,
            urlEncriptada: src[f.key] ?? null,
            urlPublica:    this.fotosDetalle[f.key]        ?? null,
            loading:       this.fotosDetalleLoading[f.key] ?? false,
            error:         this.fotosDetalleError[f.key]   ?? null,
        })).filter(f => f.urlEncriptada);
    },
  },
};
</script>

<style scoped lang="scss">
$navy:#0A354E; $white:#fff; $g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

.hv-wrap { background:$bg; min-height:100vh; padding:1.25rem .5rem; }

/* ── Selección de empresa ── */
.hv-empresa-selector { display:flex; align-items:center; gap:1rem; background:$white; border:1px solid $g200; border-radius:$r; padding:1.25rem 1.5rem; margin-bottom:1.25rem; }
.hv-empresa-icon { width:44px; height:44px; border-radius:10px; background:#eff6ff; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.2rem;color:#1e40af;} }
.hv-empresa-body { flex:1; }
.hv-empresa-title { font-size:.85rem; font-weight:700; color:$g700; margin-bottom:.5rem; }

/* ── Topbar ── */
.hv-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1.25rem; flex-wrap:wrap; gap:.75rem; }
.hv-title  { font-size:1.35rem; font-weight:700; color:$g700; margin:0 0 .2rem; display:flex; align-items:center; gap:.6rem; }
.hv-sub    { font-size:.8rem; color:$g500; margin:0; }
.hv-topbar-actions { display:flex; gap:.65rem; }
.hv-badge-total { display:inline-flex; align-items:center; justify-content:center; background:#dbeafe; color:#1d4ed8; font-size:.72rem; font-weight:700; border-radius:20px; padding:.1rem .6rem; }

/* ── Buttons ── */
.hv-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.hv-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }
.hv-btn-icon { display:inline-flex; align-items:center; justify-content:center; width:30px; height:30px; background:$white; border:1px solid $g200; border-radius:6px; cursor:pointer; color:$g700; font-size:.82rem; transition:all .15s; &:hover{border-color:$navy;color:$navy;} }
.hv-btn-icon--ok     { color:#16a34a; border-color:#86efac; background:#f0fdf4; }
.hv-btn-icon--warn   { color:#d97706; border-color:#fcd34d; background:#fffbeb; }
.hv-btn-icon--danger { color:#dc2626; border-color:#fca5a5; background:#fef2f2; }

/* ── Filtros ── */
.hv-filtros { padding:.25rem; display:flex; flex-direction:column; gap:.875rem; }
.hv-filtros-title { display:flex; align-items:center; gap:.5rem; font-size:.9rem; font-weight:700; color:$navy; padding-bottom:.75rem; border-bottom:1px solid $g200; i{font-size:14px;} }
.hv-filtros-grid  { display:grid; grid-template-columns:1fr 1fr; gap:.75rem; }
.hv-filtros-field { display:flex; flex-direction:column; gap:.3rem; label{font-size:.68rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.hv-filtros-actions { display:flex; justify-content:flex-end; gap:.65rem; padding-top:.75rem; border-top:1px solid $g200; }

/* ── Tabla ── */
.hv-tabla-wrap {
  background:$white; border:1px solid $g200; border-radius:$r;
  overflow-x:auto;   // ← permite scroll horizontal
  overflow-y:visible;
  -webkit-overflow-scrolling: touch;
}
// Agrega dentro de .hv-tabla:
.hv-tabla { width:100%; border-collapse:collapse; font-size:.82rem; min-width:900px; }
//                                                                    ^^^^^^^^^^^^^^
.hv-tabla thead tr { background:#f8f9fa; }
.hv-tabla th { text-align:left; padding:.65rem 1rem; font-size:.63rem; font-weight:700; letter-spacing:.7px; text-transform:uppercase; color:$g500; border-bottom:1px solid $g200; white-space:nowrap; }
.hv-tabla td { padding:.75rem 1rem; border-bottom:1px solid #f1f3f4; color:$g700; vertical-align:middle; }
.hv-tabla tbody tr:last-child td { border-bottom:none; }
.hv-tabla tbody tr:hover td { background:#fafbfc; }
.hv-tabla--sm th, .hv-tabla--sm td { padding:.55rem .75rem; }
.hv-center { text-align:center; }

/* Celdas tabla */
.hv-foto-wrap { width:48px; height:36px; border-radius:6px; overflow:hidden; }
.hv-foto { width:100%; height:100%; object-fit:cover; }
.hv-foto-placeholder { width:48px; height:36px; background:#e2e8f0; border-radius:6px; display:flex; align-items:center; justify-content:center; i{color:#94a3b8;font-size:1.1rem;} }
.hv-placa-badge { display:inline-block; background:$navy; color:white; font-weight:700; font-size:.75rem; padding:3px 10px; border-radius:5px; letter-spacing:1px; }
.hv-placa-badge-lg { display:inline-block; background:white; color:$navy; font-size:1.1rem; font-weight:800; padding:4px 14px; border-radius:6px; letter-spacing:2px; }
.hv-sub  { font-size:.72rem; color:#94a3b8; margin-top:2px; }
.hv-strong { font-weight:600; color:$g700; }
.hv-rojo { color:#dc2626 !important; }
.hv-chip { display:inline-block; background:#f1f5f9; border:1px solid #e2e8f0; border-radius:20px; padding:2px 10px; font-size:.72rem; font-weight:600; color:#475569; }
.hv-chip-blue { background:#dbeafe; color:#1d4ed8; border-color:#bfdbfe; }
.hv-tag-sec { display:inline-block; background:#f1f5f9; color:#64748b; font-size:.68rem; font-weight:600; padding:1px 6px; border-radius:4px; }
.hv-mono { font-family:monospace; font-size:.79rem; color:$g700; }
.hv-bold { font-weight:700; }
.hv-sync-fecha { font-size:.76rem; color:#64748b; }
.hv-acciones { display:flex; gap:.35rem; }

/* Status badges */
.hv-status { display:inline-block; font-size:.7rem; font-weight:700; padding:.2rem .55rem; border-radius:20px; white-space:nowrap; }
.hv-status--ok     { background:#f0fdf4; color:#16a34a; }
.hv-status--danger { background:#fef2f2; color:#dc2626; }
.hv-status--warn   { background:#fffbeb; color:#d97706; }
.hv-status--sec    { background:#f1f5f9; color:#64748b; }
.hv-status--info   { background:#eff6ff; color:#2563eb; }

/* Count badges */
.hv-count { display:inline-flex; align-items:center; justify-content:center; min-width:24px; height:24px; padding:0 6px; border-radius:12px; font-size:.78rem; font-weight:700; }
.hv-count--ok     { background:#f0fdf4; color:#16a34a; }
.hv-count--danger { background:#fef2f2; color:#dc2626; }
.hv-count--warn   { background:#fffbeb; color:#d97706; }

/* Paginación */
.hv-pagination { display:flex; justify-content:space-between; align-items:center; padding:.75rem 1rem; border-top:1px solid $g200; flex-wrap:wrap; gap:.5rem; font-size:.78rem; color:$g500; }
.hv-pagination-left { display:flex; align-items:center; gap:.5rem; }
.hv-pag-label { font-size:.75rem; color:$g500; }
.hv-per-page { border:1px solid $g200; border-radius:6px; padding:.25rem .5rem; font-size:.78rem; color:$g700; background:$white; cursor:pointer; &:focus{outline:none; border-color:$navy;} }
.hv-pag-info { font-size:.78rem; color:$g500; }
.hv-paginator { background:transparent; border:none; }

/* Empty */
.hv-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:5rem 2rem; text-align:center; h3{color:$g700;margin-bottom:.5rem;} p{color:$g500;margin-bottom:1.5rem;} }
.hv-empty-icon { width:80px; height:80px; background:#e0f2fe; border-radius:50%; display:flex; align-items:center; justify-content:center; margin-bottom:1.25rem; i{font-size:2.5rem;color:#0369a1;} }

/* ── Skeleton ── */
@keyframes shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
.hv-skeleton-row { height:52px; border-radius:6px; background:linear-gradient(90deg,#ececec 25%,#f5f5f5 50%,#ececec 75%); background-size:1200px; animation:shimmer 1.4s infinite linear; }

/* ── Modal ── */
.hv-dialog {
  :deep(.p-dialog-header) { font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:1.5rem; }
  :deep(.p-dialog-footer) { border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; gap:.65rem; }
}

.hv-modal-header { display:flex; align-items:flex-start; gap:1.25rem; background:linear-gradient(135deg,#0A354E 0%,#0c4f77 100%); border-radius:10px; padding:1.25rem 1.5rem; color:white; flex-wrap:wrap; }
.hv-modal-icon { width:52px; height:52px; background:rgba(255,255,255,.15); border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.6rem;color:white;} }
.hv-modal-main { flex:1; min-width:180px; }
.hv-modal-title { font-size:1.05rem; font-weight:700; margin-top:4px; display:flex; align-items:center; gap:.5rem; flex-wrap:wrap; }
.hv-modelo-pill { background:rgba(255,255,255,.2); border-radius:20px; padding:1px 10px; font-size:.75rem; font-weight:500; }
.hv-modal-sub { font-size:.75rem; color:rgba(255,255,255,.7); margin-top:3px; }
.hv-modal-badges { display:flex; gap:1.25rem; flex-wrap:wrap; align-items:flex-start; }
.hv-badge-item { display:flex; flex-direction:column; align-items:center; gap:4px; }
.hv-badge-lbl  { font-size:.65rem; color:rgba(255,255,255,.7); font-weight:600; text-transform:uppercase; }
.hv-badge-fecha { font-size:.65rem; color:rgba(255,255,255,.6); }

/* Secciones datos */
.hv-seccion-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(240px,1fr)); gap:1rem; }
.hv-seccion { border:1px solid #e5e7eb; border-radius:8px; padding:1rem; background:#fafbfc; }
.hv-seccion-titulo { font-size:.72rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; margin-bottom:.75rem; display:flex; align-items:center; gap:6px; i{font-size:.78rem;} }
.hv-kv-grid { display:grid; grid-template-columns:120px 1fr; gap:.35rem .5rem; font-size:.8rem; }
.hv-kv-lbl { font-weight:600; color:#64748b; }

/* Póliza cards */
.hv-poliza-card { border:1px solid #e5e7eb; border-radius:8px; padding:1rem 1.25rem; margin-bottom:.75rem; background:#f9fafb; &.hv-poliza-vigente{border-color:#86efac;background:#f0fdf4;} }
.hv-poliza-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:.75rem; }
.hv-poliza-entidad { font-weight:700; font-size:.85rem; color:$g700; }
.hv-poliza-kv { display:grid; grid-template-columns:repeat(auto-fit,minmax(150px,1fr)); gap:.4rem 1rem; font-size:.8rem; div{display:flex;flex-direction:column;gap:1px;} }
.hv-fecha-ok     { color:#16a34a; font-weight:700; }
.hv-fecha-vencida{ color:#dc2626; }

/* SIMIT */
.hv-simit-clean { display:flex; flex-direction:column; align-items:center; padding:2.5rem 1rem; text-align:center; gap:.5rem; strong{font-size:1rem;color:#166534;} p{color:#4b7a60;font-size:.875rem;margin:0;} }
.hv-simit-icon  { font-size:3rem; color:#22c55e; }
.hv-deuda-resumen { display:flex; justify-content:space-around; flex-wrap:wrap; gap:.5rem; padding:.875rem 1.25rem; background:#fef2f2; border:1px solid #fecaca; border-radius:8px; }
.hv-deuda-item  { display:flex; flex-direction:column; align-items:center; gap:.3rem; }
.hv-deuda-total { font-size:1rem; color:#dc2626; font-weight:700; }
.hv-simit-nota  { font-size:.72rem; color:#94a3b8; display:flex; align-items:center; gap:.4rem; i{font-size:.72rem;} }
.hv-tab-badge   { display:inline-flex; align-items:center; justify-content:center; width:18px; height:18px; background:#dc2626; color:white; border-radius:50%; font-size:.65rem; font-weight:700; margin-left:.4rem; }
.hv-empty-tab   { display:flex; align-items:center; gap:.5rem; padding:2rem 1rem; color:#94a3b8; font-size:.875rem; i{font-size:1.25rem;color:#e2e8f0;} }

/* Responsive */
@media(max-width:768px){
  .hv-topbar { flex-direction:column; align-items:flex-start; }
  .hv-seccion-grid { grid-template-columns:1fr; }
  .hv-kv-grid { grid-template-columns:100px 1fr; }
  .hv-modal-header { flex-direction:column; }
  .hv-tabla { font-size:.75rem; }
  .hv-tabla th, .hv-tabla td { padding:.5rem .6rem; }
  .hv-filtros-grid { grid-template-columns:1fr; }
}
@media(max-width:1280px){
  // Ocultar Propietario y Comb./Servicio — info menos urgente
  .hv-tabla th:nth-child(6),
  .hv-tabla td:nth-child(6),
  .hv-tabla th:nth-child(11),
  .hv-tabla td:nth-child(11) { display:none; }
}

@media(max-width:1024px){
  // Además ocultar Modelo
  .hv-tabla th:nth-child(4),
  .hv-tabla td:nth-child(4) { display:none; }
}
/* ── Fotos detalle modal ── */
.hv-fotos-det-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}
.hv-foto-det-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fafbfc;
}
.hv-foto-det-header {
  display: flex; align-items: center;
  padding: .5rem .75rem;
  background: #f1f5f9;
  border-bottom: 1px solid #e5e7eb;
  font-size: .72rem; font-weight: 700; color: $navy;
  i { font-size: .75rem; }
}
.hv-foto-det-preview { display: flex; flex-direction: column; }
.hv-foto-det-img {
  width: 100%; height: 160px; object-fit: cover; display: block;
}
.hv-foto-det-open {
  text-align: center; font-size: .72rem; color: $navy; font-weight: 600;
  padding: .35rem; background: #eff6ff; text-decoration: none;
  border-top: 1px solid #bfdbfe;
  display: flex; align-items: center; justify-content: center; gap: .25rem;
  &:hover { background: #dbeafe; }
}
.hv-foto-det-placeholder {
  height: 160px;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  gap: .35rem; color: #94a3b8; padding: 1rem; text-align: center;
  i { font-size: 1.5rem; }
  span { font-size: .8rem; }
  small { font-size: .7rem; color: #cbd5e1; }

  &--clickable {
    cursor: pointer; transition: background .15s;
    &:hover { background: #eff6ff; color: $navy; }
  }
  &--loading { color: #3b82f6; i { color: #3b82f6; } }
  &--error   { color: #dc2626; i { font-size: 1.25rem; color: #dc2626; } }
}
.hv-tab-badge--blue { background: #2563eb; }

/* Fotos modal registro (ModalNuevoVehiculo) */
// Agregar en el style del modal:
.mhv-fotos-seccion-titulo {
  font-size: .72rem; font-weight: 700; color: $navy;
  text-transform: uppercase; letter-spacing: .5px;
  display: flex; align-items: center; gap: .4rem;
  margin-bottom: .75rem;
}
.mhv-fotos-grid-doc {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
  margin-bottom: .5rem;
}
.mhv-foto-doc-card {
  border: 1px solid #e5e7eb; border-radius: 8px;
  overflow: hidden; background: #fafbfc;
}
.mhv-foto-doc-header {
  display: flex; align-items: center;
  padding: .5rem .75rem; background: #f1f5f9;
  border-bottom: 1px solid #e5e7eb;
  font-size: .72rem; font-weight: 700; color: $navy;
}
.mhv-foto-doc-preview { display: flex; flex-direction: column; }
.mhv-foto-doc-img {
  width: 100%; height: 150px; object-fit: cover; display: block;
}
.mhv-foto-doc-open {
  text-align: center; font-size: .7rem; color: $navy; font-weight: 600;
  padding: .3rem; background: #eff6ff; text-decoration: none;
  border-top: 1px solid #bfdbfe;
  display: flex; align-items: center; justify-content: center; gap: .25rem;
  &:hover { background: #dbeafe; }
}
.mhv-foto-doc-placeholder {
  height: 150px;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  gap: .35rem; color: #94a3b8; text-align: center; padding: .75rem;
  i { font-size: 1.5rem; }
  span { font-size: .78rem; }
  small { font-size: .68rem; color: #cbd5e1; }

  &--clickable {
    cursor: pointer; transition: background .15s;
    &:hover { background: #eff6ff; color: $navy; }
  }
  &--loading { color: #3b82f6; }
  &--error   { color: #dc2626; }
}
.mhv-btn-sm { padding: .3rem .65rem; font-size: .75rem; }
.mhv-tab-badge--blue { background: #2563eb; }
</style>